module.exports = __webpack_public_path__ + "static/artists-37ab3c1c13b8b3148e7ae293a9ab6e99.jpg";